export default function DualScore({ opportunity, confidence, size = "md" }) {
  const bar = (val, color) => (
    <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
      <div className={`h-full ${color}`} style={{ width: `${Math.max(0, Math.min(100, val))}%` }} />
    </div>
  );
  const font = size === "lg" ? "text-2xl" : "text-lg";
  return (
    <div className="grid grid-cols-2 gap-4">
      <div data-testid="opportunity-score-block">
        <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">Opportunity</div>
        <div className={`${font} font-bold font-mono text-slate-900`}>{opportunity}<span className="text-slate-400 text-sm">/100</span></div>
        {bar(opportunity, "bg-slate-900")}
      </div>
      <div data-testid="confidence-score-block">
        <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">Confidence</div>
        <div className={`${font} font-bold font-mono text-[#C25E00]`}>{confidence}<span className="text-slate-400 text-sm">/100</span></div>
        {bar(confidence, "bg-[#C25E00]")}
      </div>
    </div>
  );
}
